import { select } from '@soltalabs/stateless'
import { ForecastModule } from './module'
import { prop } from '@soltalabs/ramda-extra'

const { state$ } = ForecastModule

const forecastTime$ = select(state$, prop('forecastTime'))
const forecastStartTimes$ = select(state$, prop('forecastStartTimes'))

export { forecastTime$, forecastStartTimes$ }
